<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="data === undefined">
      <h4 class="alert-heading">
        Ошибка получения данных
      </h4>
      <div class="alert-body">
        Не удалось найти обьект с данным id. Проверьте
        <b-link
          class="alert-link"
          :to="{ name: 'measurements-measurement-list'}"
        >
          Список обьектов
        </b-link>
        список обьектов.
      </div>
    </b-alert>


    <template v-if="data">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="9"
          lg="8"
          md="7"
        >
          <measurement-info-card :measurement-data="data" />
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <measurement-user-card :user-data="data.user"></measurement-user-card>
        </b-col>
        <b-col>
          <b-tabs>
            <b-tab title="Заметки">
              <measurement-notes-card :notes-data="data.note"/>
            </b-tab>
            <b-tab title="Приложения">
              <measurement-attachments-card :attachments-data="data.attachment"/>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>

  import store from '@/store'
  import { STORE_MODULE_NAME, STORE_MODULE_CONFIG}  from '../measurementStoreModule';

  import {ref, onBeforeMount, onBeforeUnmount, onMounted} from '@vue/composition-api'

  import router from '@/router'

import {
  BRow, BCol, BAlert, BLink, BTabs, BTab,
} from 'bootstrap-vue'

  import useMeasurement from '../useMeasurement'


import MeasurementInfoCard from "../components/MeasurementInfoCard";
import MeasurementNotesCard from "../components/MeasurementNotesCard";
import MeasurementAttachmentsCard from "../components/MeasurementAttachmentsCard";
import MeasurementUserCard from "../components/MeasurementUserCard";


export default {
  components: {
    MeasurementUserCard,
    MeasurementAttachmentsCard,
    MeasurementNotesCard,
    BRow,
    BCol,
    BAlert,
    BLink,
    BTabs,
    BTab,

    // Local Components
    MeasurementInfoCard,


  },
  setup() {

      const data = ref(null)

      const {fetchDataUrl} = useMeasurement()

      // Re-register module with additional options
      onBeforeMount(() => {

        if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, STORE_MODULE_CONFIG)
      })

        // UnRegister on leave
      onBeforeUnmount(() => {
          if (!store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
      })

      onMounted( async ()=>{
        await store.dispatch(fetchDataUrl, { id: router.currentRoute.params.id })
                .then(response => { data.value = response.data })
                .catch((err) => {})
      })

      return {
        data,
      }
    },
}
</script>
